import React, { FC } from 'react';

import Input from '../../components/Input/Input';
import { InputFields, RawField } from '../../forms';
import Logo from '../Logo';

const Reset: FC = () => {
  const FormFields = {
    password1: { ...InputFields.password, required: true, name: 'password1' },
    password2: { ...InputFields.password, required: true, name: 'password2', label: '再⼊⼒(確認)' },
  } as const satisfies Record<string, RawField>;

  return (
    <form className='auth-form' method='post'>
      <Logo />
      <h3>新しいパスワード</h3>
      <p>任意のパスワード※英大文字・数字をそれぞれ最低１文字以上含み、10文字以上である必要があります。</p>
      <Input
        label={FormFields.password1.label}
        inputProps={{
          tabIndex: FormFields.password1.tabIndex,
          required: FormFields.password1.required,
          maxLength: FormFields.password1.maxLength,
          pattern: FormFields.password1.pattern,
        }}
        type={FormFields.password1.type}
        name={FormFields.password1.name}
        size='small'
        fullWidth
        sx={{ width: '300px' }}
      />

      <Input
        label={FormFields.password2.label}
        inputProps={{
          tabIndex: FormFields.password2.tabIndex,
          required: FormFields.password2.required,
          maxLength: FormFields.password2.maxLength,
          pattern: FormFields.password2.pattern,
        }}
        type={FormFields.password2.type}
        name={FormFields.password2.name}
        size='small'
        fullWidth
        sx={{ width: '300px' }}
      />

      <button className='btn btn--main btn--fix' type='submit'>
        送信
      </button>
    </form>
  );
};

export default Reset;
